import { render } from "./_form-captcha.vue?vue&type=template&id=3895f36c"
import script from "./_form-captcha.vue?vue&type=script&lang=js"
export * from "./_form-captcha.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__